import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';

function GoogleLoginButton({ onSuccess, text = 'signin_with', size = 'large', width = 280 }) {
    const { loginWithGoogle } = useAuth();

    return (
        <GoogleLogin
            onSuccess={async (response) => {
                if (!response?.credential) return;
                try {
                    await loginWithGoogle(response.credential);
                    if (onSuccess) onSuccess();
                } catch {
                    alert('Não foi possível fazer login com Google. Tente novamente.');
                }
            }}
            onError={() => {
                alert('Login com Google cancelado ou falhou.');
            }}
            text={text}
            size={size}
            width={width}
            locale="pt-BR"
        />
    );
}

export default GoogleLoginButton;
